export default __webpack_public_path__ + "media/images/icons/info-grid-d7397fc8c733dea7ac1d15b1812f67db.svg";